<template>
  <el-dialog title="温馨提示" :visible.sync="show" width="388px" class="contractWrapper" @close="$emit('cancel')">
    <div class="box">
      <p class="upPara">此功能仅付费会员可用，会员费：500元/年。 </p>
      <p class="upPara"> 请打款至以下账户后，将付款截屏发送至邮箱：</p>
      <p class="upPara"> payment@dream-abc.com</p>
      <p class="upPara">我们会在48小时内为您开通。</p>
      <div class="down">
        <p class="downtitle">收款账户：</p>
        <p class="downPara">名称：上海知身为信息网络科技有限公司</p>
        <p class="downPara">开户行：中国民生银行上海春申支行</p>
        <p class="downPara">账号：172201808</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Contract',
  props: {
    onlieContractVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      form: {
        account: '',
        question: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ],
        question: [
          { required: true, message: '请输入您的问题', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    onlieContractVisible: {
      handler (nval) {
        this.show = nval
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    closeMe () {
      this.resetForm('contractForm')
      this.$emit('cancel')
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .contractWrapper{
    height: 100%;
    width: 100%;
    border-radius: 12px;
    .box{
      width: 100%;
      height: 214px;
      padding-top: 20px;
      font-size: 14px;
      font-family: 'PingFang SC';
      color: #333;
      text-align: center;
      line-height: 22px;
      border-top: 1px solid #eee;
      .upPara{
        margin: 0;
      }
      .down{
        height: 112px;
        width: 340px;
        background-color: #F5FAFF;
        .downtitle{
          height: 40px;
          font-weight: 600;
          line-height: 40px;
          margin: 20px 0 0 0;
        }
        .downPara{
          margin: 0;
        }
      }
    }
  }
  .el-dialog{
    border-radius: 12px;
  }
</style>
